interface Props {
  color?: string
  width?: number
  height?: number
}

export const OutlineIcon = ({ color = '#6F6F6F', width = 22, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="10" stroke={color} strokeWidth="2" />
      <path d="M4 18L17 5" stroke={color} strokeLinecap="round" />
    </svg>
  )
}
